// First, before anything that builds a schema — see the file for why.
import '@/app/zod';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router';
import { ApiFailure } from '@/lib/api';
import { AppRoutes } from '@/app/router';
import { SessionProvider } from '@/app/session';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A coach pitch-side reloads a lot; served-then-revalidated beats a spinner.
      staleTime: 30_000,
      retry: (attempt, error) => {
        // Retrying a 4xx just repeats the same rejection. Retry transport faults only.
        if (error instanceof ApiFailure && error.status < 500) return false;
        return attempt < 2;
      },
      refetchOnWindowFocus: false,
    },
  },
});

const root = document.getElementById('root');
if (!root) throw new Error('#root missing from index.html');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <SessionProvider>
          <AppRoutes />
        </SessionProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
